<template>
<v-menu
  v-model='visible'
  bottom right
  :close-on-click="true"
  :close-on-content-click="false"
  transition="slide-x-transition" >
  <v-btn slot="activator" icon >
    <v-icon>filter_list</v-icon>
  </v-btn>

  <v-card :min-width="280" :max-width="280" flat >
    <v-card-title class='subheading py-0' >
        Filter results
        <v-spacer ></v-spacer>
        <v-btn @click='visible=false' icon small ><v-icon>close</v-icon></v-btn>
    </v-card-title>
    <v-divider></v-divider>
    <v-subheader>Date Range</v-subheader>
    <v-dialog
      ref="dialog"
      v-model="fromModal"
      lazy full-width
      width="290px" >
      <v-text-field class='px-3 py-0 mb-0'
        slot="activator"
        v-model="fromDate"
        label="Start date"
        prepend-icon="event"
        clearable readonly >
      </v-text-field>
      <v-date-picker
        v-model="fromDate"
        :max='toDate' >
      </v-date-picker>
    </v-dialog>

    <v-dialog
      ref="dialog"
      v-model="toModal"
      lazy full-width
      width="290px" >
      <v-text-field class='px-3 py-0 mb-0'
        slot="activator"
        v-model="toDate"
        label="End date"
        prepend-icon="event"
        clearable readonly >
      </v-text-field>
      <v-date-picker
        v-model="toDate"
        :min='fromDate' >
      </v-date-picker>
    </v-dialog>

    <v-list dense >
      <v-subheader>Appointment Status</v-subheader>
      <v-checkbox
        v-model='showAllStatuses'
        class='ml-2'
        label="Show all statuses" ></v-checkbox>
      <v-list
        transition="slide-y-transition"
        v-if='!showAllStatuses' >
          <v-list-tile
            v-for='(status, index) in statuses'
            :key=status.id >
            <v-list-tile-content >
              <v-list-tile-title>
                <label>
                  <input
                    v-model='selectedStatusIds'
                    :value='index'
                    type='checkbox' class='mr-2' />
                    {{status.title}}
                </label>
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
      </v-list>
    </v-list>
    <v-card-text>
      {{filtersAsSentence}}
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions >
      <v-spacer></v-spacer>
      <v-btn
        @click='emitFilters'
        class='primary'> Apply filters</v-btn>
    </v-card-actions>
  </v-card>
</v-menu>
</template>

<script>
import {STATUSES} from '@/store/constants'

export default {
  name: 'StatementFilters',
  props: {
    filterFromDate: { type: String },
    filterToDate: { type: String },
    filterStatusIds: { type: Array },
    touchShow: { type: Number, default: 1 }, // incremend this to make the filters show
    noFiltersText: { type: String, default: 'No filters applied. #nofilter' }
  },
  data () {
    return {
      visible: false,
      fromModal: false,
      toModal: false,
      statuses: STATUSES,
      fromDate: null,
      toDate: null,
      showAllStatuses: true,
      selectedStatuses: [],
      selectedStatusIds: []
    }
  },
  mounted () {
    this.emitFilters()
  },
  methods: {
    emitFilters () {
      this.$emit('filters:string', this.filtersAsSentence)
      this.$emit('filters:params', this.filters)
    }
  },
  computed: {
    hasFilters () {
      return this.fromDate || this.toDate || this.selectedStatusIds.length > 0
    },
    filters () {
      let filters = {}
      if (this.fromDate) {
        filters['from_date'] = this.fromDate
      }
      if (this.toDate) {
        filters['to_date'] = this.toDate
      }
      if (this.selectedStatusIds &&
          this.selectedStatusIds.length > 0 &&
          !this.showAllStatuses) {
        filters['statuses'] = this.selectedStatusIds.join(',')
      }
      return filters
    },
    dateRangeFormatted () {
      if (this.fromDate && this.toDate) {
        return `between ${this.fromDate} and ${this.toDate}`
      }
      if (this.fromDate) {
        return `from ${this.fromDate}`
      }
      if (this.toDate) {
        return `before ${this.toDate}`
      }
      return 'from any date'
    },
    selectedStatusAsString () {
      if (this.showAllStatuses === true) { return 'of any status' }
      let statusNames = this.selectedStatusIds.map((statusId) => {
        return this.statuses[statusId].title
      })
      // let statusIds = this.selectedStatuses.map((stat) => {
      //   return stat.id
      // })
      let prefix = 'with status: '
      if (statusNames.length === 0) { return '' }
      if (statusNames.length === 1) { return prefix + statusNames[0] }

      let lastStatus = statusNames.pop()
      return prefix + statusNames.join(', ') + ' and ' + lastStatus
    },
    filtersAsSentence () {
      if (!this.hasFilters) { return this.noFiltersText }
      return `Appointments ${this.selectedStatusAsString} ${this.dateRangeFormatted}`
    }
  },
  watch: {
    fromDate () {
      this.fromModal = false
    },
    toDate () {
      this.toModal = false
    },
    touchShow () {
      this.visible = true
    },
    filterFromDate: {
      immediate: true,
      handler () {
        if (this.filterFromDate) {
          this.fromDate = this.filterFromDate
        }
      }
    },
    filterToDate: {
      immediate: true,
      handler () {
        if (this.filterToDate) {
          this.toDate = this.filterToDate
        }
      }
    },
    filterStatusIds: {
      immediate: true,
      handler () {
        if (this.filterStatusIds && this.filterStatusIds.length > 0) {
          this.showAllStatuses = false
          this.selectedStatuses = []
          this.filterStatusIds.forEach((id) => {
            this.selectedStatuses.push(this.statuses[id])
          })
        } else {
          this.showAllStatuses = true
        }
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// Filters.vue?05f8f66e